/*==========================================================================
        initialiseProjects
==========================================================================*/
portfolioAPP.initialiseProjects = function () {

  fixedSidebarLeftTop = document.querySelector('.landscape #fixedSidebarLeft').getBoundingClientRect().top
  fixedSidebarRightTop = document.querySelector('.landscape #fixedSidebarRight').getBoundingClientRect().top

  // Wait for all images in mainRight container to load before calculating
  var mainRightEl = document.querySelector('.contentSidebarLeft .mainRight');
  
  if (mainRightEl) {
    // Wait for low-resolution placeholder images to load, then calculate immediately
    // The placeholder images have dimensions, so we can calculate height right away
    $(mainRightEl).imagesLoaded(function() {
      calculateHeights();
    });
  } else {
    calculateHeights();
  }
  
  function calculateHeights() {
    var mainRightEl = document.querySelector('.contentSidebarLeft .mainRight');
    var mainRightHeight = 0;
    
    if (mainRightEl) {
      var screenshotDivs = mainRightEl.querySelectorAll('.projectScreenshot1');
      
      // Try multiple methods and use the largest one for accuracy
      var scrollHeight = mainRightEl.scrollHeight;
      var offsetHeight = mainRightEl.offsetHeight;
      
      // For multiple images, sum individual div heights for accurate calculation
      if (screenshotDivs.length > 1) {
        var sumHeight = 0;
        screenshotDivs.forEach(function(div) {
          sumHeight += div.offsetHeight; // Use offsetHeight for summing
        });
        
        // Use the maximum of container height methods and sum
        mainRightHeight = Math.max(scrollHeight, offsetHeight, sumHeight);
      } else {
        // Single image - use container height
        mainRightHeight = Math.max(scrollHeight, offsetHeight);
      }
    }
    
    var fixedSidebarLeftEl = document.querySelector('.landscape #fixedSidebarLeft');
    var fixedSidebarLeftHeight = fixedSidebarLeftEl ? fixedSidebarLeftEl.getBoundingClientRect().height : 0;
    
    fixedSidebarLeftDuration = mainRightHeight - fixedSidebarLeftHeight;
    
    var mainLeftEl = document.querySelector('.contentSidebarRight .mainLeft');
    var fixedSidebarRightEl = document.querySelector('.landscape #fixedSidebarRight');
    var mainLeftHeight = mainLeftEl ? mainLeftEl.getBoundingClientRect().height : 0;
    var fixedSidebarRightHeight = fixedSidebarRightEl ? fixedSidebarRightEl.getBoundingClientRect().height : 0;
    fixedSidebarRightDuration = mainLeftHeight - fixedSidebarRightHeight;
    
    if (portfolioAPP.onInitialise()!='isTouchDevice'){
      portfolioAPP.projectsScrollMagic()
    }
  }
}
/*==========================================================================
        initialiseProjects
==========================================================================*/





/*==========================================================================
        onResizeProjects
==========================================================================*/
portfolioAPP.onResizeProjects = function () {
  var w = window,
  d = document,
  e = d.documentElement,
  g = d.getElementsByTagName('body')[0],
  x = w.innerWidth || e.clientWidth || g.clientWidth;

  var width = $(window).width();
  $(window).on('resize', function() {
    
    if ($(this).width() != width) {
      width = $(this).width();

    var t = w.innerWidth || e.clientWidth || g.clientWidth;
    if(t !== x) {

      screenHeight = $(window).height();

      mainController.destroy(true);

      window.mainController = new ScrollMagic.Controller({refreshInterval: 0})

      if (scrollBar){
        scrollBar.removeListener(portfolioAPP.projectsStickySectionLeft)
        scrollBar.removeListener(portfolioAPP.projectsStickySectionRight)
      }

      document.querySelector('.landscape #fixedSidebarLeft').style.top = 0;
      document.querySelector('.landscape #fixedSidebarRight').style.top = 0;

      fixedSidebarLeftTop = document.querySelector('.landscape #fixedSidebarLeft').getBoundingClientRect().top
      fixedSidebarRightTop = document.querySelector('.landscape #fixedSidebarRight').getBoundingClientRect().top

      // Calculate left sidebar duration - handle multiple images same as initialiseProjects
      var mainRightEl = document.querySelector('.contentSidebarLeft .mainRight');
      var mainRightHeight = 0;
      
      if (mainRightEl) {
        var screenshotDivs = mainRightEl.querySelectorAll('.projectScreenshot1');
        var scrollHeight = mainRightEl.scrollHeight;
        var offsetHeight = mainRightEl.offsetHeight;
        
        if (screenshotDivs.length > 1) {
          // Multiple images - sum individual div heights
          var sumHeight = 0;
          screenshotDivs.forEach(function(div) {
            sumHeight += div.offsetHeight;
          });
          mainRightHeight = Math.max(scrollHeight, offsetHeight, sumHeight);
        } else {
          // Single image - use container height
          mainRightHeight = Math.max(scrollHeight, offsetHeight);
        }
      }
      
      fixedSidebarLeftDuration = mainRightHeight - document.querySelector('.landscape #fixedSidebarLeft').getBoundingClientRect().height;
      
      fixedSidebarRightDuration = document.querySelector('.contentSidebarRight .mainLeft').getBoundingClientRect().height - document.querySelector('.landscape #fixedSidebarRight').getBoundingClientRect().height

      
  
      if ((portfolioAPP.onInitialise()!='isTouchDevice')){
        portfolioAPP.projectsScrollMagic()
        portfolioAPP.smoothScroll()
        scrollBar.setPosition(0, 0)
      }else{
        window.scrollTo(0, 0)
      }

    }
    arrayOffsets = [screenHeight, screenHeight * .1, screenHeight * .2, screenHeight * .3, screenHeight * .4, screenHeight * .5]
    }

  });

}
/*==========================================================================
        onResizeProjects
==========================================================================*/















/*==========================================================================
        projectsPreLoader
==========================================================================*/
portfolioAPP.projectsPreLoader = function () {
  let preloaderAnimation = loader.imagesLoader()
  preloaderAnimation.to($(".preloaderWrapProjects .progress span"), 1, {
    width: 100,
    ease: Linear.easeNone
  })
}
/*==========================================================================
        projectsPreLoader
==========================================================================*/



/*==========================================================================
        projectsStickySection
==========================================================================*/
portfolioAPP.projectsStickySectionLeft = function (status) {
  if (portfolioAPP.onInitialise()=='isLargeScreen'){
    var offset = status.offset;
    document.querySelector('.landscape #fixedSidebarLeft').style.top = offset.y - fixedSidebarLeftTop + 'px';
  }
}

portfolioAPP.projectsStickySectionRight = function (status) {
  if (portfolioAPP.onInitialise()=='isLargeScreen'){
    var offset = status.offset;
    document.querySelector('.landscape #fixedSidebarRight').style.top = offset.y - fixedSidebarRightTop + 'px';
  }
}
/*==========================================================================
        projectsStickySection
==========================================================================*/



/*==========================================================================
        projectsLinks
==========================================================================*/
portfolioAPP.projectsLinks = function () {
  Array.from(document.querySelectorAll('.grid__item-img')).forEach((el) => {
    const imgs = Array.from(el.querySelectorAll('img'));
    new hoverEffect({
      parent: el,
      intensity: el.dataset.intensity || undefined,
      speedIn: el.dataset.speedin || undefined,
      speedOut: el.dataset.speedout || undefined,
      easing: el.dataset.easing || undefined,
      hover: el.dataset.hover || undefined,
      image1: imgs[0].getAttribute('src'),
      image2: imgs[1].getAttribute('src'),
      displacementImage: el.dataset.displacement
    });
  });
}
/*==========================================================================
        projectsLinks
==========================================================================*/



/*==========================================================================
        projectsScrollMagic
==========================================================================*/
portfolioAPP.projectsScrollMagic = function () {

  // -----------------  animationprojectClayMockup
  var projectClayMockup = new TimelineMax()
  projectClayMockup
    .to($(".projectClayMockup1 img"), 1, { y: -arrayOffsets[2] })
  scenes.push(
    new ScrollMagic.Scene({
      triggerElement: ".projectClayMockup1",
      triggerHook: .75,
      duration: "100%"
    })
    .setTween(projectClayMockup)
    //.addIndicators({ name: "animationAbout" })
    .addTo(mainController)
  )


  scenes.push(
    new ScrollMagic.Scene({
      triggerElement: ".contentSidebarLeft",
      triggerHook: 0,
      offset: 0,
      duration: fixedSidebarLeftDuration
    })
    .reverse(true)
    .on("enter", function (event) {
      //console.log('FIXED!')
      if (portfolioAPP.onInitialise()!='isTouchDevice'){
      scrollBar.addListener(portfolioAPP.projectsStickySectionLeft);
      }
      //animationHeaderAvatar.play();
    })
    .on("leave", function (event) {
      //console.log('RELEASED!')
      //animationHeaderAvatar.reverse();
      if (portfolioAPP.onInitialise()!='isTouchDevice'){
      scrollBar.removeListener(portfolioAPP.projectsStickySectionLeft);
      }
    })
    //.addIndicators({ name: "animationContentSidebarLeft" })
    .addTo(mainController)
  )

  scenes.push(
    new ScrollMagic.Scene({
      triggerElement: ".contentSidebarRight",
      triggerHook: 0,
      offset: 0,
      duration: fixedSidebarRightDuration
    })
    .reverse(true)
    .on("enter", function (event) {
      //console.log('FIXED!')

      scrollBar.addListener(portfolioAPP.projectsStickySectionRight);

      //animationHeaderAvatar.play();
    })
    .on("leave", function (event) {
      //console.log('RELEASED!')
      //animationHeaderAvatar.reverse();
      scrollBar.removeListener(portfolioAPP.projectsStickySectionRight);
    })
    //.addIndicators({ name: "animationContentSidebarRight" })
    .addTo(mainController)
  )

}
/*==========================================================================
        projectsScrollMagic
==========================================================================*/